<!-- ── Search hero ─────────────────────────────────────────────────────────── -->
<section class="tg-page-hero">
  <div class="tg-container">
    <h1 class="tg-page-hero__title">Candidatos Tech</h1>
    <p class="tg-page-hero__sub">Encuentra el talento tecnológico que tu empresa necesita</p>

    <form class="tg-search-bar">
      <div class="tg-search-bar__fields">
        <div class="tg-search-bar__field">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 15.803 7.5 7.5 0 0 0 15.803 15.803z"/>
          </svg>
          <input type="text" placeholder="¿Qué habilidad estás buscando?..." [formControl]="titulo" />
        </div>
        <div class="tg-search-bar__field">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0z"/>
          </svg>
          <input type="text" placeholder="País" [formControl]="pais">
        </div>
        <div class="tg-search-bar__field">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25zM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25z"/>
          </svg>
          <select (change)="onSelect($event.target.value)">
            <option value="" disabled selected hidden>Categoría</option>
            <option value="{{categoria.idCategoria}}" *ngFor="let categoria of categoriasCandidatos">
              {{categoria.nombreCategoria}}
            </option>
          </select>
        </div>
      </div>
      <button type="submit" class="tg-btn tg-btn--primary" (click)="getPalabra()">Buscar</button>
    </form>
  </div>
</section>

<!-- ── Candidates list ────────────────────────────────────────────────────────── -->
<section class="tg-section" #listaCandidatos>
  <div class="tg-container">

    <!-- Filter tabs -->
    <div class="tg-filter-tabs">
      <button class="tg-filter-tabs__btn active" type="button" (click)="selecAll()">Todos</button>
      <button class="tg-filter-tabs__btn" type="button" (click)="obtenerCandidatosNuevos()">Nuevos</button>
      <button class="tg-filter-tabs__btn" type="button" (click)="obtenerCandidatosDestacados()">Destacados</button>
      <button class="tg-filter-tabs__btn" type="button" (click)="selecSueldos()">Por Sueldo</button>
      <button class="tg-filter-tabs__btn" type="button" (click)="selecExperiencia()">Por Experiencia</button>

      <div class="tg-filter-tabs__sub" *ngIf="mostrarSueldos">
        <button class="tg-filter-tabs__btn" type="button" (click)="seleccionarSalario(10000)">$5,000–$10,000</button>
        <button class="tg-filter-tabs__btn" type="button" (click)="seleccionarSalario(25000)">$10,000–$25,000</button>
        <button class="tg-filter-tabs__btn" type="button" (click)="seleccionarSalario(40000)">$25,000–$40,000</button>
        <button class="tg-filter-tabs__btn" type="button" (click)="seleccionarSalario(45000)">+$40,000</button>
      </div>

      <div class="tg-filter-tabs__sub" *ngIf="mostrarAnioExperiencia">
        <button class="tg-filter-tabs__btn" type="button" (click)="seleccionarExperiencia(0)">Recién egresados</button>
        <button class="tg-filter-tabs__btn" type="button" (click)="seleccionarExperiencia(1)">1 a 3 años</button>
        <button class="tg-filter-tabs__btn" type="button" (click)="seleccionarExperiencia(3)">+3 años</button>
      </div>
    </div>

    <div class="alert alert-danger" *ngIf="mensajeError">{{mensajeError}}</div>

    <!-- Grid -->
    <div class="row">
      <div class="col-sm-6 col-lg-3 mb-4"
           *ngFor="let candidato of candidatos | paginate: {itemsPerPage: cantidadCandidatos, currentPage: noPagina}">
        <div class="tg-candidate-card">
          <img class="tg-candidate-card__img" loading="lazy"
               [src]="candidato.imagen"
               [alt]="candidato.nombre + ' ' + candidato.apellidos"
               [title]="candidato.nombre + ' ' + candidato.apellidos">
          <h2 class="tg-candidate-card__name">{{ candidato.nombre | titlecase }} {{ candidato.apellidos | titlecase }}</h2>
          <p class="tg-candidate-card__escolaridad">{{ candidato.escolaridad }}</p>
          <a class="tg-candidate-card__link" routerLink="/candidatos/detalles/{{candidato.idCandidato}}">
            Ver Perfil
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/>
            </svg>
          </a>
        </div>
      </div>
    </div>

    <!-- Empty state -->
    <div class="text-center py-5" *ngIf="candidatos?.length === 0">
      <p style="color:#6b7280;">No se encontraron candidatos con los filtros seleccionados.</p>
    </div>

    <!-- Pagination -->
    <div class="d-flex justify-content-center mt-4">
      <pagination-controls class="page-numbers"
        (pageChange)="noPagina = $event"
        (click)="scrollToElement(listaCandidatos)"
        [responsive]="true"
        [previousLabel]="''"
        [nextLabel]="''">
      </pagination-controls>
    </div>

  </div>
</section>
